const Button=({text, className,onclick})=>
{
    return(
        <div>
            <button id="activeeffect" onClick={onclick} className={`cursor-pointer hover:bg-[#a77202] py-[15px] bg-[#C69130] text-white text-[16px] font-[500] leading-[20px] ${className}`}>{text}</button>
        </div>
    )
}
export default Button